<template>
    <div class="promocode">
        <form v-on:submit.prevent="submitHandler">
            <input type="text" autocomplete="off" name="promocode" v-model="promocode" :placeholder="trans.tickets.promocode.input">
            <button type="submit" :class="['button button-big', {disabled: loading}]">{{ loading ? '...' :  trans.tickets.promocode.apply }}</button>
        </form>
        <div :class="'alert ' + alert.type">{{ alert.message }}</div>
    </div>
</template>

<style lang="scss" scoped>
    .promocode {
        width: 100%;
        padding: 32px 32px 50px;
    }

    form {
        text-align: center;
    }

    input {
        width: 100%;
    }

    button {
        margin-top: 1rem;
        min-width: 180px;
    }

    .alert {
        text-align: center;
        padding: 1rem;
        font-size: 1rem;

        &.success {
            color: var(--color-green);
        }

        &.error {
            color: var(--color-red);
        }
    }

    @media (min-width: 992px) {
        form {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }

        input {
            width: auto;
            min-width: 310px;
        }

        button {
            margin-top: 0;
            margin-left: 1rem;
        }
    }
</style>

<script>
    export default {
        props: {
            submitCallBack: Function,
            trans: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                loading: false,
                promocode: '',
                alert: {
                    type: 'success',
                    message: this.trans.tickets.promocode.instructions,
                }
            }
        },

        methods: {
            submitHandler() {
                this.loading = true
                this.alert = {}

                const request = axios.get('/api/promocode', {
                    params: {
                        promocode: this.promocode,
                        site: this.trans.domain.site
                    },
                })

                request.then(({ data }) => {
                    this.loading = false

                    if (!data.tickets || data.tickets.length === 0) {
                        this.alert = {
                            type: 'error',
                            message: this.trans.tickets.promocode.invalid,
                        }

                        return this.submitCallBack(null)
                    }

                    this.alert = {
                        type: 'success',
                        message: this.trans.tickets.promocode.success,
                    }

                    return this.submitCallBack({
                        promocode: this.promocode,
                        ...data
                    })
                }).catch(error => {
                    console.error(error)
                    this.loading = false
                    this.alert = {
                        type: 'error',
                        message: 'Opps! Error.',
                    }
                })

            }
        },
    }
</script>
